export default __webpack_public_path__ + "static/media/img-ovato-coin-perspective-new.e39b7c54.jpg";